import React from 'react';

import { usePageStore } from '@client/store/pageStore/context/pageContext';
import { CsvDataPoint, SpectrogramPoint } from '@ledium/types';
import { DownloadSpectrumCsv } from '@ledium/ui-common';
import { Grid } from '@mui/material';

const SpectrumMixerDownloadCsv = () => {
    const {
        pageState: { formData }
    } = usePageStore();

    const aggregatedSpectrogram = formData.aggregatedSpectrogram as SpectrogramPoint[] | undefined;

    if (!aggregatedSpectrogram || !aggregatedSpectrogram.some((point) => point.irradiance > 0)) {
        return null;
    }

    const csvData: CsvDataPoint[] = aggregatedSpectrogram.map((point) => ({
        waveLength: point.waveLength,
        value: point.irradiance
    }));

    const filename = `spectrum-mix${formData.name ? '-' + (formData.name as string) : ''}.csv`;

    return (
        <Grid item xs={12} sx={{ textAlign: 'center' }}>
            <DownloadSpectrumCsv data={csvData} filename={filename} />
        </Grid>
    );
};

export default SpectrumMixerDownloadCsv;
